export default class Team {
    constructor(data) {
        this.data = {};
        this.data = data;
    }
    get id() {
        return this.data.id;
    }
    get name() {
        return this.data.calendarProviderName || this.data.name;
    }
    get dateUpdated() {
        return this.data.dateUpdated;
    }
    get slug() {
        return this.data.slug;
    }
    get nosOfCalendars() {
        return this.data.nos_of_calendars;
    }
    set nosOfCalendars(value) {
        this.data.nos_of_calendars = value;
    }
}
